import React from 'react'; // eslint-disable-line
import AppWrapper from '../structure/AppWrapper';
import AppHeader from '../structure/AppHeader';
import i18n from '../../i18n';

const PermissionsMessage = (props) => {
    return (
        <AppWrapper>
            <AppHeader>{i18n.t('permissions.header')}</AppHeader>
            <div className="text-center">
                {
                    props.match.params === 'profile-not-allowed'
                        ? <p>{i18n.t('permissions.error-not-allowed')}</p>
                        : (
                            <p>
                                <strong>{i18n.t('permissions.default-error.header')}</strong>
                                {i18n.t('permissions.default-error.message')}
                            </p>
                        )
                }
            </div>
        </AppWrapper>
    );
};

export default PermissionsMessage;
